import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-confirm-dialog__inner-content" }
const _hoisted_2 = { class: "app-confirm-dialog__message" }
const _hoisted_3 = { class: "app-confirm-dialog__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_app_dialog = _resolveComponent("app-dialog")!

  return (_openBlock(), _createBlock(_component_app_dialog, {
    "require-action": "",
    class: "app-confirm-dialog"
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_base_button, _mergeProps({
            class: "app-confirm-dialog__button app-confirm-dialog__button--cancel",
            tabindex: "1"
          }, _ctx.cancelProps, {
            onClick: ($event: any) => (_ctx.action('cancel', close))
          }), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.cancelLabel), 1)
            ]),
            _: 2
          }, 1040, ["onClick"]),
          _createVNode(_component_base_button, _mergeProps({
            class: "app-confirm-dialog__button app-confirm-dialog__button--confirm",
            tabindex: "2"
          }, _ctx.confirmProps, {
            onClick: ($event: any) => (_ctx.action('confirm', close))
          }), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
            ]),
            _: 2
          }, 1040, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}